// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyChcEYqvZCnHBJPrwLhyLQTaC5rp4JHl2g",
    authDomain: "canada60app.firebaseapp.com",
    projectId: "canada60app",
    storageBucket: "canada60app.firebasestorage.app",
    messagingSenderId: "435380673244",
    appId: "1:435380673244:web:255794a4049c3a7026f219",
    measurementId: "G-EZWK9YSJD5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app); // Initialize analytics
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
